var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("menu-switch", {
    staticClass: "hamburger-container",
    staticStyle: {
      display: "inline-block",
      "padding-left": "10px",
      position: "relative",
      top: "3px"
    },
    attrs: {
      "toggle-click": _vm.toggleSideBar,
      "is-active": _vm.sidebar.opened
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89d3b5f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89d3b5f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/MenuSwitchButton.vue
// module id = 567
// module chunks = 75